import { useMutation, useQuery } from '@apollo/client'
import { useHistory } from 'react-router-dom'
import { Button } from '@winnin/winnin_ui.components.button'
import { useToast } from '@winnin/winnin_ui.components.toast'

import { useTranslate } from 'lib/tolgee'
import { PanelStore } from 'stores'
import { datadog } from 'utils'
import getSavedSearchURL from 'utils/getSavedSearchURL'

import { CREATE_OWNED_TOPIC_LOG_ERROR } from './logs'
import { CREATE_OWNED_TOPIC, SEARCH_VIDEOS_QUERY } from './query'
import { TOLGEE_KEYS } from './translate'

import './index.scss'

interface IFiltersView {
  searchFilter: string
}

export default function ButtonSearchFilter({ searchFilter }: IFiltersView) {
  const history = useHistory()
  const t = useTranslate()
  const { createToast } = useToast()

  const { data: videoData } = useQuery(SEARCH_VIDEOS_QUERY, {
    variables: {
      query: {
        title: searchFilter,
        timeRange: {
          timeUnit: 'day',
          timeValue: 7,
        },
      },
    },
  })

  const [createOwnedTopic, { loading }] = useMutation(CREATE_OWNED_TOPIC, {
    onCompleted({ createSavedPostSearch }) {
      if (createSavedPostSearch?.success === false && createSavedPostSearch?.message === 'Unable due to plan limit') {
        return createToast({
          content: t(TOLGEE_KEYS.errorToast),
        })
      }

      const workspaceId = (PanelStore?.selectedPanel as any)?.id

      const savedSearchURL = getSavedSearchURL(createSavedPostSearch, workspaceId)

      history.push(savedSearchURL)
    },
  })

  const posts = videoData?.searchPosts?.rows > 0

  const handleClick = async () => {
    const filtersParams = new URLSearchParams()

    filtersParams.set('title', searchFilter)

    const variables = {
      savedPostSearch: {
        name: searchFilter,
        query: searchFilter,
        filters: filtersParams.toString(),
      },
    }
    try {
      createOwnedTopic({
        variables,
      })
    } catch (error) {
      datadog.dispatchRequestErrorLog({
        error,
        log: CREATE_OWNED_TOPIC_LOG_ERROR,
        query: {
          name: 'CREATE_OWNED_TOPIC',
          variables,
        },
      })
    }
  }

  if (!searchFilter || !posts) {
    return null
  }

  return (
    <div className="ButtonSearchFilter">
      {t(TOLGEE_KEYS.description({ searchFilter }))}
      <Button appearance="link" disabled={loading} onClick={handleClick}>
        {t(TOLGEE_KEYS.button)}
      </Button>
    </div>
  )
}
